import { useDoorData } from "app/hooks";
import { useMonthlyPayments } from "app/hooks/checkout/useMonthlyPayment";
import { useMemo } from "react";
import { SuggestedProductCard } from "./SuggestedProductCard";
import { SuggestedProductCardSkeleton } from "./SuggestedProductCardSkeleton";
// Define an array of suggested door product codes
const SUGGESTED_DOOR_PRODUCTS_CODES = [
  "opdekdeur",
  "taatsdeur",
  "schuifdeur",
  "opdekdeurmetkozijn",
];

const SuggestedProductsGrid = () => {
  const { isDoorDataLoading, doorData } = useDoorData();

  // Memoize the result array of suggested door products based on the doorData
  const suggestedDoorProducts = useMemo(() => {
    if (!doorData) return [];
    return doorData.filter((door) =>
      SUGGESTED_DOOR_PRODUCTS_CODES.includes(door.code)
    );
  }, [doorData]);

  // Memoize the result array of product prices based on the suggested door products
  const productPrices = useMemo(
    () => suggestedDoorProducts.map((product) => product.price),
    [suggestedDoorProducts]
  );

  // Get the monthly payments for the product prices using the useQueries hook
  const monthlyPayments = useMonthlyPayments(productPrices);

  return (
    <div
      className={"gg-max-w-5xl xl:gg-max-w-6xl gg-pb-20 lg:gg-px-6 xl:gg-px-0"}
    >
      <h2 className="gg-text-3xl sm:gg-text-4xl gg-text-slate-800 gg-mb-5 gg-font-bold">
        Is dit wat je zoekt?
      </h2>

      <div className=" gg-grid gg-grid-cols-1 gg-gap-y-5 sm:gg-gap-7 sm:gg-grid-cols-2 lg:gg-grid-cols-4 xl:gg-gap-x-12  ">
        {/* If door data is loading, show a skeleton of cards */}
        {isDoorDataLoading && <SuggestedProductCardSkeleton />}

        {/* If there is available door data, map the products  */}
        {suggestedDoorProducts.map((product, index) => {
          const paymentData = monthlyPayments[index].data?.monthlyPayment;

          return (
            <SuggestedProductCard
              key={index}
              paymentData={paymentData}
              product={product}
            />
          );
        })}
      </div>
    </div>
  );
};
export default SuggestedProductsGrid;
